import { createContext } from 'react';

const UserContext = createContext({
    isLoggedIn: false,
    userData: null,
    loading: true,
    role: null,
    firstName: null,
    setUser: () => {},
    setIsLoggedIn: () => {},
    setRole: () => {},
    setFirstName: () => {},
});

export default UserContext;